import { usePayReady } from "@/api/payment/usePayReady";

export const PaymentTestPage = () => {
  const { mutate: pay, isPending } = usePayReady();

  const handlePayment = () => {
    // These values should come from your application's state/context
    const paymentDetails = {
      itemName: "Test Item",
      totalPrice: 1000,
      orderId: `test_order_${new Date().getTime()}`,
      userId: "test_user_123",
    };
    pay(paymentDetails);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Payment Test Page</h1>
      <p>Click the button below to start the KakaoPay test flow.</p>
      <button onClick={handlePayment} disabled={isPending}>
        {isPending ? "Processing..." : "Pay with KakaoPay"}
      </button>
    </div>
  );
};
